'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isTuesday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isTuesday.js
// module id = 249
// module chunks = 1